module.exports = __webpack_public_path__ + "content/698e3c6e522f6948637426e907ba3188.svg";